module.exports = __webpack_public_path__ + "img/data-view-ai-usage-active.df5c6cb1.svg";